export default __webpack_public_path__ + "static/media/footerlogo.e663f9a5.png";